import React from "react";
import axios from "axios";

export const ocrApi = async (urlid) => {
  try {
    let url = `https://ocr.tcore.online/convert?url=${urlid}`;

    const response = await axios.get(url);
    const AllData = {
      data: response.data,
    };
    return AllData;
  } catch (error) {
    const AllData = {
      error: error,
    };
    return AllData;
  }
};
